import { TabItem } from 'components/FormikFields/FormikTabSelect/FormikTabSelect'

export const MARINE_CONDITION_ITEMS: TabItem[] = [
    { value: 'N', label: 'New' },
    { value: 'U', label: 'Pre-owned' },
]
